import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CtaButton } from './CtaButton';

// Sections where the bar would duplicate an on-screen CTA or cover the hero.
const HIDE_WHEN_VISIBLE = ['top', 'offer', 'final-cta'];
export function StickyMobileCta() {
  const [visibleIds, setVisibleIds] = useState<Set<string>>(new Set(['top']));
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      setVisibleIds(previous => {
        const next = new Set(previous);
        entries.forEach(entry => {
          if (entry.isIntersecting) next.add(entry.target.id);else next.delete(entry.target.id);
        });
        return next;
      });
    });
    HIDE_WHEN_VISIBLE.forEach(id => {
      const element = document.getElementById(id);
      if (element) observer.observe(element);
    });
    return () => observer.disconnect();
  }, []);
  const isShown = visibleIds.size === 0;
  return <AnimatePresence data-id="element-163" data-mp="29gvzs0mpsb15">
      {isShown && <motion.div initial={reduceMotion ? {
      opacity: 0
    } : {
      y: '100%'
    }} animate={reduceMotion ? {
      opacity: 1
    } : {
      y: 0
    }} exit={reduceMotion ? {
      opacity: 0
    } : {
      y: '100%'
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-ivory/10 bg-forest-dark/95 px-5 py-3 backdrop-blur md:hidden" data-id="element-164" data-mp="29k1rzoqn3t13">
          <CtaButton tone="onDark" fullWidth data-id="element-165" data-mp="1lswcjaom32rb" />
        </motion.div>}
    </AnimatePresence>;
}